import { withPrefix } from 'gatsby';
import { Helmet } from 'react-helmet';
import { useCookiePreferences } from 'components/CookiePreferences/CookiePreferencesProvider';

export const VWO = () => {
  const cookiePreferences = useCookiePreferences();

  if (!cookiePreferences?.performance) return null;

  return (
    <Helmet>
      <link rel="preconnect" href="https://dev.visualwebsiteoptimizer.com" />
      <script type="text/javascript" src={withPrefix('vwo.js')} id="vwoCode" />
    </Helmet>
  );
};
